import {getService} from "~/lib/services/services-manager";

export const getStats = async (clientUuid, specs) => {
  const service = getService("server-app");
  const result = await service.post(`/admin-client/stats/${clientUuid}`, {
    ...specs,
    pagination: {
      perPage: specs.pagination.limit,
      page: specs.pagination.offset,
    }
  });
  return result.data;
};

export const downloadStatFiltered = async (clientUuid, specs) => {
  const service = getService("server-app");
  const result = await service.post(`/admin-client/stats/${clientUuid}/download`, {
    ...specs,
    pagination: {
      perPage: specs.pagination.limit,
      page: specs.pagination.offset,
    }
  });
  return result.data;
};

export const downloadStat = async (clientUuid) => {
  const service = getService("server-app");
  const result = await service.get(`/admin/stats/${clientUuid}/download`);
  return result.data;
};
